import { ref } from 'vue'

// Simple reactive state for dynamic breadcrumb label
export const dynamicLabel = ref<string | null>(null)

export function setDynamicLabel(label: string | null) {
  dynamicLabel.value = label
}
